<div class="col-sm-12 no-padding">
  <div class="accordion" id="accordion2BA">
    <div class="accordion-group">
      <div class="accordion-heading">
        <button (click)="toggleAccordionBA()" class="accordion-toggle btn btn-link btn-block clearfix accordion-btn" data-toggle="collapse" data-parent="#accordion2" href="#collapseOneBA">
          <div class="row">
            <div class="pull-left font-weight-light bp-text bp-small-text col-md-8 text-align-left no-padding"><i class="fas arrowdiv-ba arrowdiv fa-chevron-right"></i> BUDGET ALERT</div>
            <div *ngIf="textSubscribedBA || emailSubscribedBA" class="col-md-4 green text-align-right">Subscribed</div>
            <div *ngIf="!textSubscribedBA && !emailSubscribedBA" class="col-md-4"></div>
          </div>
        </button>
      </div>
      <div id="collapseOneBA" class="accordion-body collapse">
        <div class="row">
          <div class="col-sm-12 no-padding">
            <p class="text-align-left title-small font-weight-light bp-text bp-x-small-text">
              Whenever Budget exceeds by more than the percentage that you set, you will be alerted.
            </p>
          </div>
        </div>
        <div class="accordion-inner">
          <div *ngIf="!subscribedBA" class="row subscribeSection">
            <div class="row" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <button type="button" class="btn btn-light bp-text bp-medium-text" style="font-weight: 600;color: #3F8F8B;" (click)="onSubscribeClick()">+ SUBSCRIBE</button>
            </div>
          </div>
          <div *ngIf="subscribedBA" class="row subscribeSection">
            <div class="row" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <div class="col-sm-12">
                <label for="ba-buffer-input">Budget Alarm Trigger (%):</label>
                <input type="number" value="{{percentInput}}" (ngModel)="percentInput" class="form-control" (change)="setPercentValue($event.target.value)" id="ba-buffer-input" />
              </div>
            </div>
            <div class="row" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <div class="col-sm-12"><span class="bp-text bp-small-text">Contact Type:</span></div>
              <div class="col-sm-12">
                <div class="btn-group">
                  <label class="btn btn-primary subscription-container" (click)="showEmailInput()"
                         btnRadio="email" tabindex="0" role="button"><i style="margin-right: 0.3rem;" class="far fa-envelope"></i>Email</label>
                  <label class="btn btn-primary subscription-container" (click)="showPhoneSelect()"
                         btnRadio="text" tabindex="0" role="button"><i style="margin-right: 0.3rem;" class="fas fa-mobile-alt"></i>Text</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12"><span style="float:left;" class="bp-text bp-small-text">Destination:</span></div>
            </div>
            <div class="row" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <div class="col-sm-12 bp-text bp-small-text">
                <div *ngIf="showPhoneBA" class="form-group">
                  <span>
                    <select class="form-control select-medium" name="phone" [(ngModel)]="accountPhoneBA">
                      <option *ngFor="let phone of accountPhonesBA" [value]="phone">{{ phone }}</option>
                    </select>
                  </span>
                  <div class="margin-top-10">
                    <small class="green" *ngIf="textSubscribedBA"> (Text Subscribed)</small>
                    <input type="text" class="btn btn-xs btn-danger float-right" *ngIf="textSubscribedBA" (click)="removeBAAlert(true, false)" value="Remove Text Alerts" />
                  </div>
                </div>
                <div *ngIf="showEmailBA">
                  <span class="bp-text bp-bold-text" *ngIf="showEmailBA">{{accountEmailBA}}</span>
                  <div class="margin-top-10">
                    <small class="green" *ngIf="emailSubscribedBA"> (Email Subscribed)</small>
                    <input type="text" class="btn btn-xs btn-danger float-right" *ngIf="emailSubscribedBA" (click)="removeBAAlert(false, true)" value="Remove Email Alerts" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row bp-text bp-small-text" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <div class="col-sm-12"><button (click)="onSaveBAAlertClick()" class="btn btn-primary" type="button">SAVE</button></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/budget-alerts/budget-alerts.component.html